export interface DistributionRecordToken {
  id: string
  staffProgressVersion: number
  assignmentVersion: number
}

/** Build the exact visible-page selection sent to the server; hidden-page ids are never dropped silently. */
export function buildDistributionSelection(
  records: readonly DistributionRecordToken[],
  selectedIds: ReadonlySet<string>,
): Array<{
  recordId: string
  expectedStaffProgressVersion: number
  expectedAssignmentVersion: number
}> {
  return records
    .filter((record) => selectedIds.has(record.id))
    .map((record) => ({
      recordId: record.id,
      expectedStaffProgressVersion: record.staffProgressVersion,
      expectedAssignmentVersion: record.assignmentVersion,
    }))
}

export function distributionPreviewKey(
  selection: readonly { recordId: string; expectedStaffProgressVersion: number; expectedAssignmentVersion: number }[],
  staff: readonly { staffId: string; tier: number }[],
): string {
  return JSON.stringify({ selection, staff })
}

/** Copy the exact confirmation payload so later selection/target changes cannot retarget it. */
export function manualAssignmentRequest(records: readonly { id: string; assignmentVersion: number }[], target: string | null) {
  return { updates: records.map(record => ({ recordId: record.id, expectedAssignmentVersion: record.assignmentVersion, assignedStaffId: target })) }
}

export function ownerFilterQuery(value: string): string | null {
  return value === "all" ? null : value
}
